import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.isMobile
        ? _c(
            _setup.CoreBottomSheet,
            {
              attrs: { value: _vm.isActive, title: _vm.title },
              on: { input: _setup.handleInput },
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [
                            _c(
                              VBtn,
                              {
                                staticClass:
                                  "primary--text branding-btn branding-btn--background",
                                attrs: {
                                  block: "",
                                  elevation: "0",
                                  color: "bg-primary",
                                  "data-qa": "award-winner-dialog-more",
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.emit("redirect")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_setup.buttonText) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2688093093
              ),
            },
            [
              _c("div", { staticClass: "text-body-1 text--text" }, [
                _vm._v("\n      " + _vm._s(_setup.description) + "\n    "),
              ]),
            ]
          )
        : _c(
            _setup.CoreDialog,
            {
              attrs: {
                divider: "",
                size: "md",
                value: _vm.isActive,
                title: _vm.title,
              },
              on: { input: _setup.handleInput },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            text: "",
                            "data-qa": "award-winner-dialog-close",
                          },
                          on: {
                            click: function ($event) {
                              return _setup.emit("input", false)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _setup.i18next.t("Закрыть", {
                                  ns: _setup.i18next.language,
                                })
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          staticClass: "branding-btn branding-btn--primary",
                          attrs: {
                            text: "",
                            color: "primary",
                            "data-qa": "award-winner-dialog-more",
                          },
                          on: {
                            click: function ($event) {
                              return _setup.emit("redirect")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.buttonText) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("div", { staticClass: "text-body-1 text--text" }, [
                _vm._v("\n      " + _vm._s(_setup.description) + "\n    "),
              ]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }